import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TextareaModule } from 'primeng/textarea';
import { CharacterCounterComponent } from '../../miscs/character-counter/character-counter.component';
import { FormLabelComponent } from '../form-label/form-label.component';

@Component({
    selector: 'textarea-ng',
    standalone: true,
    imports: [FormLabelComponent, TextareaModule, FormsModule, TranslateModule, CharacterCounterComponent],
    templateUrl: './textarea.component.html',
    styleUrl: './textarea.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextareaComponent {
    id = input.required<string>();
    value = model.required<string>();

    label = input<string>('');
    tooltipText = input<string>('');
    required = input<boolean>(false);
    disabled = input<boolean>(false);
    invalid = input<boolean>(false);

    placeholder = input<string>('uiKit.form.textarea.placeholder');
    rows = input<number>(5);
    maxLength = input<number>(5000);
    size = input<'small' | 'large'>('large');
}
